import React from "react";
import "./Pipeline.scss";
import { InfoCircleOutlined, UserOutlined } from "@ant-design/icons";
import { IPipeline } from "@utils/Interfaces";

const Pipeline: React.FC<IPipeline> = ({ activePhase, phases }) => {
  return (
    <div className="Pipeline">
      <div className="Pipeline-group">
        {phases?.map((item: any, index: number) => {
          const status =
            activePhase - 1 > index
              ? "done"
              : activePhase - 1 == index
              ? "active"
              : "inactive";
          return (
            <div className={`Pipeline-item ${status}`} key={index}>
              <div className="item-grow">
                <div className="Pipeline-title">{item.text}</div>
                <div className="Pipeline-candidate-group">
                  <div className="Pipeline-candidate">
                    <UserOutlined />
                    <span>{item.target_profile}</span>
                  </div>
                  <InfoCircleOutlined />
                </div>
              </div>
              <div className="item-shrink">
                <div className="process-percent">0%</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Pipeline;
